import Vue from 'vue'
import Router from 'vue-router'
import Layout from './components/Layout.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.VUE_APP_BASE_URL,
  routes: [
    {
      path: '/:campaign',
      name: 'home',
      component: Layout
    },
    { 
        path: '*', 
        name:'catchall',
        component: Layout,
    }
  ]
})
